var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24Person = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 5.25c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5.673 1.5 1.5 1.5 1.5-.673 1.5-1.5zm1.5 0c0 1.654-1.345 3-3 3-1.654 0-3-1.346-3-3 0-1.655 1.346-3 3-3 1.655 0 3 1.345 3 3zM3.75 15c0-2.895 2.356-5.25 5.25-5.25s5.25 2.355 5.25 5.25c0 .414-.335.75-.75.75s-.75-.336-.75-.75c0-2.068-1.682-3.75-3.75-3.75S5.25 12.932 5.25 15c0 .414-.335.75-.75.75s-.75-.336-.75-.75z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24Person, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_ person.8c5c053e.svg";
export { ForwardRef as ReactComponent };